// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__24Vjc","navLink":"Nav_navLink__2GJIX","active":"Nav_active__1Znc1"};